import { useLocation } from 'react-router-dom';
import { STAFF_NAV_CATALOG } from '../../widgets/navigation/staff-route-catalog';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../shared/ui/Card';
import { Container } from '../../shared/ui/Container';

export default function NavStubPage() {
  const location = useLocation();
  const path = location.pathname.replace(/\/+$/, '') || '/';
  const meta = STAFF_NAV_CATALOG.find((e) => e.frontendPath === path);

  const title = meta?.label ?? 'Раздел';
  const description = 'Экран в разработке — интерфейс появится в следующих версиях.';
  const body = 'Бизнес-логика этого раздела будет перенесена отдельными задачами.';

  return (
    <Container maxWidth="lg">
      <Card>
        <CardHeader>
          <CardTitle>{title}</CardTitle>
          <CardDescription>{description}</CardDescription>
        </CardHeader>
        <CardContent>
          <p className="staff-text-muted staff-m-0">{body}</p>
        </CardContent>
      </Card>
    </Container>
  );
}
